import React from 'react';
import { HashRouter as DefaultRouter, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './redux/store';
import ViewForm from './containers/ViewForm';
import Login from './containers/Login';
import SignUp from './containers/SignUp';
import Home from './containers/Home';
import ProjectContainer from './containers/Projects';
import NewProjectContainer from './containers/NewProject';
import ViewProjectContainer from './containers/ViewProject';
import ParticipantsContainer from './containers/Participants';
import LiveContainer from './containers/live';
import SessionsContainer from './containers/sessions';


const App = () => {
  return (
    <Provider store={store}>
      <DefaultRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectContainer />} />
          <Route path="/new-project" element={<NewProjectContainer />} />
          <Route path="/view-project/:formId" element={<ViewProjectContainer />} />
          <Route path="/participants" element={<ParticipantsContainer />} />
          <Route path="/sessions" element={<SessionsContainer />} />
          <Route path="/lives" element={<LiveContainer />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/fill/:formId" element={<ViewForm />} />
        </Routes>
      </DefaultRouter>
    </Provider>
  );
}

export default App;
